import React, { useState, useEffect } from "react";
import "./comparison.css";
import Meta from "utils/meta";
import HubspotFeatures from "utils/ComparionData/hubspotFeatures";
import HubspotDetailedFeatures from "utils/ComparionData/hubspotDetailedFeatures";
import SubPageHeader from "Component/SubPageHeader/subPageHeader";
import ComparisonTopTabs from "Component/ComparisonTopTabs/ComparisonTopTabs";
import ComparisonSideMenu from "Component/ComparisonSideMenu/ComparisonSideMenu";
import ComparisonFeatures from "Component/ComparisonFeatures/ComparisonFeatures";
import ComparisonSalientFeatures from "Component/ComparisonSalientFeatures/ComparisonSalientFeatures";
import DetailedComparisonTable from "Component/ComparisonFeatures/DetailedComparisonTable";

const Hubspot = () => {
  const sideMenu = [
    {name: "Best Real Estate CRM", link: "top-intro-section"},
    {name: "Features: Realtor vs Hubspot", link: "comparison-features-section"},
    {name: "Salient Features", link: "comparison-salient-features"},
    {name: "Detailed Comparison", link: "detailed-comparison"}
  ];
  const [activeDetailedComparison, setActiveDetailedComparison] = useState([]);

  const handleDetailedComparisonTab = (index) => {
    if (activeDetailedComparison.includes(index)) {
      setActiveDetailedComparison(activeDetailedComparison.filter(item => item !== index));
    } else {
      setActiveDetailedComparison([...activeDetailedComparison, index]);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (<>
      <Meta title="Hubspot | The Realtor Desk" description="" />
      <div className="sub-page--outer">
        <SubPageHeader
            title="Realtor Real Estate CRM: Made in India Specifically for the Real"
            subTitle="Realtor Real Estate has been designed and developed by industry veterans with years of experience in India's real estate market, giving it an edge over competitors like HubSpot. What’s more."
        />
        <ComparisonTopTabs
            activeTab={1}
        />
        <div className="container comparison-outer">
          <div className="comp-side--menu">
            <h4>Comparison Tools</h4>
            <ComparisonSideMenu
                sideMenu={sideMenu}
                currentActive={sideMenu[0].link}
            />
          </div>
          <div className="comp-side--content">
            <div className="top-title-section" id="top-intro-section">
              <h4>Realtor Real Estate CRM: Made in India Specifically for the Real Estate Industry</h4>
              <p>Realtor Real Estate has been designed and developed by industry veterans with years of experience in India's real estate market, giving it an edge over competitors like HubSpot. What’s more, it has a low cost of ownership, offers better customer support, on-ground training, and features in-built technology created for real estate.</p>
            </div>
            <ComparisonFeatures
                features={HubspotFeatures}
                title="Better Real Estate with Realtor Features"
                platform="Hubspot"
            />
            <ComparisonSalientFeatures
                title="Salient Feature of Realtor Real Estate : An Alternative to Hubspot CRM for Real Estate"
            />
            <div className="detailed-comparison-section--outer" id="detailed-comparison">
                <h4>How Realtor Real Estate is a Better Alternative to Hubspot</h4>
                <div className="comparison-table--accordion">
                  {HubspotDetailedFeatures.map((singleFeature, index) => (
                      <div key={index} className="comparison--accordion-item">
                          <div className={`comparison--accordion-title ${activeDetailedComparison.includes(index) ? "active-title" : ""}`} onClick={() => handleDetailedComparisonTab(index)}>
                              <span>{singleFeature.tab_heading}</span>
                              {activeDetailedComparison.includes(index) ? (<i className="fa fa-minus" />) : (<i className="fa fa-plus" />)}
                          </div>
                          {activeDetailedComparison.includes(index) && (
                              <DetailedComparisonTable
                                  features={singleFeature.tab_info}
                                  platform="Hubspot"
                              />
                          )}
                      </div>
                  ))}
                </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Hubspot;
